import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import KhattabatLoginForm from "./KhattabatLoginForm";
import KhattabatWelcome from "./KhattabatWelcome";
import Footer from "../../components/Footer";

const Login = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("CORE_LOGIN", "CORE_LOGIN");
  }, []);
  const userData = getCorePersonalStore().user.get();
  const showLoginPage = !isPositiveNumber(userData.id);

  return (
    <Stack sx={{ flex: 1, alignSelf: "stretch" }}>
      <Stack alignItems="center" sx={{ flex: 1, p: 2 }}>
        <Box
          sx={{
            my: "auto",
            width: 1,
            display: "flex",
            justifyContent: "center"
          }}
        >
          {showLoginPage ? <KhattabatLoginForm /> : <KhattabatWelcome />}
        </Box>
      </Stack>
      <Footer />
    </Stack>
  );
});
export default Login;
